module.exports = __webpack_public_path__ + "static/media/6.6_preview.22e7f811.png";